import React from 'react'

const ReplaceIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path
            d="M12 5.28154C8.04005 5.28154 4.80005 8.52154 4.80005 12.4815H6.60005L4.20005 16.6215L1.80005 12.4815H3.60005C3.60005 7.86154 7.38005 4.08154 12 4.08154C14.82 4.08154 17.2801 5.46154 18.84 7.62154L18.18 8.76154C16.92 6.66154 14.64 5.28154 12 5.28154ZM20.4 12.4815H22.2001L19.8 8.34154L17.4 12.4815H19.2C19.2 16.4415 15.96 19.6815 12 19.6815C9.36005 19.6815 7.08005 18.3015 5.82005 16.2015L5.16005 17.3415C6.72005 19.5015 9.18005 20.8815 12 20.8815C16.62 20.8815 20.4 17.1015 20.4 12.4815Z"
            fill="#333333"
        />
    </svg>
)

export default ReplaceIcon
